import gsap from 'gsap'
import { colors } from '../styles/vars/colors.style'

export function disablePageScroll() {
  document.documentElement?.classList.add('disable-scroll')
  document.body.classList.add('disable-scroll')
  window.scroll.stop()
}

export function enablePageScroll() {
  document.documentElement?.classList.remove('disable-scroll')
  document.body.classList.remove('disable-scroll')
  window.scroll.start()
}

export function forceTrailingSlash(string) {
  return string[string.length - 1] === '/' ? string : string + '/'
}

export function scrollToId(id, dispatch, location) {
  let el = document.querySelector(`#${id}`)

  if (!el) return

  dispatch({ type: 'HIDE_MOBILE_NAV' })

  const distance = el.getBoundingClientRect().top
  const adjustedDuration = Math.min(Math.abs(distance / 1500), 3)

  applyNewScroll(el, adjustedDuration)

  if (location) {
    const cleanURL = forceTrailingSlash(
      location.href.replace(location.search, '')
    )
    window.history.replaceState({}, '', cleanURL)
  }
}

export function scrollToPixel(pixelValue, dispatch) {
  dispatch({ type: 'HIDE_MOBILE_NAV' })

  const distance =
    (window.scroll?.scrollTo
      ? window.scroll.scroll.instance.scroll.y
      : window.scrollY) - pixelValue
  const adjustedDuration = Math.min(Math.abs(distance / 1500), 3)

  applyNewScroll(pixelValue, adjustedDuration)
}

function applyNewScroll(target, duration) {
  if (window.scroll?.scrollTo) {
    window.scroll.scrollTo(target, {
      duration: duration * 1000,
    })
  } else {
    gsap.to(window, {
      scrollTo: target,
      duration: duration,
      ease: 'power1.inOut',
    })
  }
}

//function for checking if country cookie exists
export function countryCookieCheck(cookie) {
  if (cookie !== null) {
    return `?country=${cookie}`
  }
}

//function for checking if link is a royal caribbean link but not a UWC page or a content page, and that it doesn't already have a country param
export function externalLinkCheck(url, linkSuffix) {
  if (url) {
    const lowercaseExternalLink = url.toLowerCase()

    if (
      lowercaseExternalLink.includes('royalcaribbean.com') &&
      !lowercaseExternalLink.includes(
        'royalcaribbean.com/ultimate-world-cruise'
      ) &&
      !lowercaseExternalLink.includes('royalcaribbean.com/content') &&
      !lowercaseExternalLink.includes('?country=') &&
      linkSuffix
    ) {
      const newUrl = url + linkSuffix
      return newUrl
    } else {
      return url
    }
  }
}

export function getExpeditionColors(number) {
  switch (number) {
    case '1':
      return {
        light: colors.teal,
        dark: colors.darkTeal,
      }
    case '2':
      return {
        light: colors.lightPink,
        dark: colors.hotPink,
      }
    case '3':
      return {
        light: colors.lightOrange,
        dark: colors.deepOrange,
      }
    case '4':
      return {
        light: colors.lightGreen,
        dark: colors.green,
      }
    default:
      console.error('Invalid Expedition Number')
  }
}
